'use strict'

export let english={
  report: {
    cancel: "Cancel",
    publishReport: "Publish report",
    publishInProgress: "... publish ongoing ...",
    inProgress: " .. in progress",
    saveDraft: "Save draft",
    listLimitedTo: "The report will be limited to the",
    top5Risks: "top 5 risks",
    top5Issues: "top 5 issues"
  },
  Overview: {
    title: "Overview",
    fields: {
      period: {
        title: "Reporting period",
        help: "Select the reporting period for this Highlight Report. Double click on a date in the calendar to make it the starting date of the reporting period. Single click on a date to make it the end date."
      },
      summary: {
        title: "Summary",
        help: "What stage and lifecycle phase is the project in right now (or which tranche if you are managing a programme)? Have any major milestones just passed, or are there any in the near future? Are there any resent successes or break throughs? What are currently the main challenges? What is the general health condition?",
        description:"Describe the overall status. Assume the reader has not read the previous report or know any details up front."
      },
      performedAchivements: {
        title: "This period",
        help: "Which work packages were in execution or completed this period? Which products were completed this period? Was any products planned to be completed but was not completed this period? Was any corrective actions taken during the period?",
        description: "Describe the goals achieved this period"

      },
      plannedAchivements: {
        title: "Next period",
        help: "Which work packages will be in execution or will be completed the coming period? Which products are planned to be completed this period? Any corrective actions planned for the coming period?",
        description: "Describe the goals set for the next period"
      },
      deliveryStatus: {
        title: "Status of Deliveries",
        columns: {
          product: { title: "Planned Delivered this Stage" },
          responsible: { title: "Responsible" },
          dueDate: { title: "Due Date" },
          status: { title: "Status" }
        }
      },

      benefits: {
        title: "Benefits",
        help: "Are we on track to deliver the desired return of investment? If not, what is the difference and why? Any new benefits added to, or removed from, the business case?",
        description: "Describe how the business case is performing"
      },
      time: {
        title: "Time",
        help:"What is the latest forecast on completing this stage, and how does it compare to the approved plan? What is the latest forecast on completing the project/programme, and how does it compare to the approved plan?",
        description: "Describe how progress of the project/programme and management stage is performing against the objectives and tolerances"
      },
      cost: {
        title: "Cost",
        help:"How much is spent to date in the current stage, what is forecasted to be spent this stage and what is currently the approved spending for the stage? How much is spent to date in the project/programme, what is forecasted to be spent in the project/programme and what is currently the approved spending?",
        description: "Describe how cost of the project/programme and management stage is performing against the objectives and tolerances"
      },

      quality: {
        title: "Quality",
        help:"Have products delivered this period met the agreed quality criteria? Have the acceptance methods (testing, reviews...)  for the products this period been applied as agreed? Have the products produced to date in the project met the agreed quality criteria? Have applicable quality standards and processes been followed during this period and to date in the project?",
        description: "Describe how the functionalities and requirements of the project/programme and management stage are performing against their tolerances"
      },
      scope: {
        title: "Scope",
        help:"Were the products for this period identified and well defined - including composition and quality criteria? Are the products for this project identified and well defined? Are there any changes to the scope?",
        description: "Describe how the project/programme is performing against the agreed scope"
      },

      risk: {
        title: "Risk",
        help:"What is the current risk level in the project and how is it matching the stakeholders risk appetite?  What are the most important risks and what actions are taken?",
        description: "Describe how the current risk level is compared to the agreed risk appetite"
      },

      teamPerformance: {
        title: "Team performance",
        help: "",
        description: ""
      },
      lessonsDescription: {
        title: "Lessons",
        help: "",
        description: ""
      }
    }
  },
  Preview: {
    title: "Preview Report"
  }
};



// WEBPACK FOOTER //
// ./views/progress/labels/english.js